import { Directive, TemplateRef } from '@angular/core'

@Directive({
  selector: '[appSlideItem]',
  standalone: true
})
export class SlideItemDirective {
  constructor(public templateRef: TemplateRef<unknown>) {}
}
